module.exports = __webpack_public_path__ + "img/2.d478cee3.png";